import { Component } from '@angular/core'

@Component({
  selector: 'efp-floating-button-bottom',
  templateUrl: './floating-button-bottom.component.html',
})
export class FloatingButtonBottomComponent {
  constructor() {}
}
